import styled from 'styled-components';
import { APP_SHELL_THEME } from '@/styles/appShellTheme';

/* The app shell sets `.app-shell-main span { color: inherit }`, so every rule
   here states its colour on the element itself rather than relying on
   inheritance from a parent. */

/** Horizontal stage rail: the document's journey, left to right. */
export const ProgressRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0;
  flex-wrap: wrap;
  padding: 4px 0 12px;
`;

export const Stage = styled.div<{ $state: 'done' | 'current' | 'pending' | 'failed' }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1 0;
  min-width: 96px;
  position: relative;

  /* Connector to the previous stage, drawn behind the marker. */
  &:not(:first-child)::before {
    content: '';
    position: absolute;
    top: 9px;
    right: 50%;
    width: 100%;
    height: 2px;
    background: ${({ $state }) =>
      $state === 'pending' ? APP_SHELL_THEME.panelBorder : APP_SHELL_THEME.accent};
  }
`;

export const StageDot = styled.span<{ $state: 'done' | 'current' | 'pending' | 'failed' }>`
  position: relative;
  z-index: 1;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  border: 2px solid
    ${({ $state }) =>
      $state === 'failed'
        ? APP_SHELL_THEME.negative
        : $state === 'pending'
          ? APP_SHELL_THEME.panelBorder
          : APP_SHELL_THEME.accent};
  background: ${({ $state }) =>
    $state === 'done'
      ? APP_SHELL_THEME.accent
      : $state === 'failed'
        ? APP_SHELL_THEME.negative
        : APP_SHELL_THEME.pageBg};
  /* Doubled class: a single one loses to the shell's 'span { color: inherit }',
     which handed the tick the cell's text colour — white in dark mode by luck. */
  && {
    color: ${({ $state }) =>
      $state === 'done' || $state === 'failed' ? APP_SHELL_THEME.onAccent : APP_SHELL_THEME.text};
  }

  /* The live stage gets a halo so it reads as "here" without relying on colour
     alone, which a red/green deficiency would flatten. */
  box-shadow: ${({ $state }) =>
    $state === 'current' ? `0 0 0 4px rgba(97, 97, 215, 0.25)` : 'none'};
`;

export const StageLabel = styled.span<{ $muted?: boolean }>`
  margin-top: 8px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  color: ${({ $muted }) => ($muted ? APP_SHELL_THEME.textMuted : APP_SHELL_THEME.text)};
`;

export const StageTime = styled.span`
  margin-top: 2px;
  font-size: 11px;
  font-variant-numeric: tabular-nums;
  text-align: center;
  color: ${APP_SHELL_THEME.textMuted};
`;
